import { Patch } from 'immer';
import { decrypt } from '../../core/cryptor/cipher';
import { Sheet } from '../types';
import { SheetGroups } from '../types/sheet/sheetGroups';
import {
  SheetStorageWorkerParams,
  SnapshotInfo,
  SnapshotParams,
  SnapshotResultDataType,
  SnapshotType,
  TempVerifiedChanges,
} from './types';
import { PrimaryStorage } from '../../core/redux/auth/authTypes';
import { FsSheetWriter } from './sheets/fs/write';
import { IDBSheetWriter } from './sheets/idb/write';
import sessionStorageSingleton from '../../core/configs/sessionStorageSingleton';

export const getUserGroupsDBName = () => {
  const userId = sessionStorageSingleton.getUserId();
  return `Groups-${userId}`;
};

export const getUserSheetsIdToNameDBName = () => {
  const userId = sessionStorageSingleton.getUserId();
  return `EntityIdToName-${userId}`;
};

export const getWALDBName = (id: string, activeWAL: number) =>
  `${id}-wal-${activeWAL}`;

export const getActiveWALLocal = (id: string) =>
  Number(localStorage.getItem(`${id}/activeWAL`)) ?? 1;
export const setActiveWALLocal = (id: string, activeWAL: number) =>
  localStorage.setItem(`${id}/activeWAL`, `${activeWAL}`);

export const getInitialSnapshotInfo = (): SnapshotInfo => ({
  activeWAL: 0,
  lastSerial: 0,
  mergedWAL: 0,
});

export const prepareSnapshotData = (snapshotParams: SnapshotParams) => {
  let data = '';
  if (snapshotParams.snapshotType === SnapshotType.Groups) {
    data = JSON.stringify(snapshotParams.groups);
  } else if (snapshotParams.snapshotType === SnapshotType.Sheet) {
    // TODO: remove flags from sheet (if any)
    data = JSON.stringify(snapshotParams.sheet);
  } else if (snapshotParams.snapshotType === SnapshotType.EntityIdToName) {
    data = JSON.stringify(snapshotParams.sheetsIdToName);
  }

  return data;
};

export const decryptSnapshotData = async <T extends SnapshotResultDataType>(
  feKey: CryptoKey,
  encData: string
) => {
  const decData = await decrypt(encData, feKey);
  const parsed = JSON.parse(decData);

  let data: T | null = parsed;

  return data;
};

export const sortChanges = (
  verifiedChanges: TempVerifiedChanges[],
  unVerifiedChanges: Patch[][]
): Patch[][] =>
  verifiedChanges
    .sort((a, b) => {
      return a.serverAssignedSerial - b.serverAssignedSerial;
    })
    .map((item) => item.changes)
    .concat(unVerifiedChanges);

const idbSheetWriter = new IDBSheetWriter();
const fsSheetWriter = new FsSheetWriter();

export const saveDataInSheetStorage = async (
  params: SheetStorageWorkerParams
) => {
  const {
    // userId,
    feKey,
    dbName,
    primaryStorage,
    snapshotParams,
    walParams,
    // unSavedSheetHistoryParams,
    directoryHandle,
  } = params;

  if (primaryStorage === PrimaryStorage.IndexedDB) {
    if (walParams) {
      await idbSheetWriter.saveChanges(feKey, dbName, walParams);
    } else if (snapshotParams) {
      await idbSheetWriter.saveSnapshot(feKey, dbName, snapshotParams);
    }
  } else if (primaryStorage === PrimaryStorage.FileSystem && directoryHandle) {
    if (walParams) {
      await fsSheetWriter.saveChanges(directoryHandle, feKey, dbName, walParams);
    } else if (snapshotParams) {
      await fsSheetWriter.saveSnapshot(
        directoryHandle,
        feKey,
        dbName,
        snapshotParams
      );
    }
  }
};
